import ModalContent from '@/components/modal/ModalContent.tsx';
import { TextInput } from '@/components/form/TextInput.tsx';
import CheckboxInput from '@/components/form/CheckboxInput.tsx';
import { useFormContext } from 'react-hook-form';
import React, { useState } from 'react';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import InputHint from '@/components/form/base/InputHint.tsx';
import { CheckboxCustomFieldInputData } from '@/features/dashboard/tourCustomFields/schemas/checkboxCustomFieldSchema.ts';
import PrimitiveCheckbox from '@/components/form/_primitives/PrimitiveCheckbox.tsx';

const CheckboxCustomFieldForm = () => {
  const {
    register,
    formState: { errors },
    getValues,
  } = useFormContext<CheckboxCustomFieldInputData>();

  const [previewChecked, setPreviewChecked] = useState(
    getValues('defaultValue'),
  );

  return (
    <>
      <ModalContent>
        <div className="text-sm text-neutral-600">
          Skonfiguruj jak powinno wyświetlać się to pole w formularzu.
        </div>

        <TextInput
          label="Nazwa pola"
          register={register('fieldName')}
          placeholder="Wpisz nazwę pola..."
          required={true}
          error={errors.fieldName?.message}
          hint="Tak będzie oznaczone to pole na formularzu "
        />

        <CheckboxInput
          label="Pole wymagane"
          register={register('isFieldMandatory')}
          error={errors.isFieldMandatory?.message}
        />

        <CheckboxInput
          label="Zaznaczone domyślnie"
          register={register('defaultValue')}
          error={errors.defaultValue?.message}
          hint="Pole będzie zaznaczone przy otwieraniu formularza"
          onChange={(e) => setPreviewChecked(e.currentTarget.checked)}
        />

        <TextInput
          label="Tekst pomocniczy"
          register={register('hint')}
          placeholder="Wpisz tekst pomocniczy..."
          error={errors.hint?.message}
          hint="Pojawi się poniżej pola, może wyjaśnić uczestnikowi jak powinien wypełnić pole"
        />
      </ModalContent>
      <ModalContent>
        <h3 className="text-xl font-semibold leading-[120%]">Podgląd</h3>
      </ModalContent>
      <ModalContent className="bg-neutral-100">
        <CustomFieldCheckboxPreview
          checked={previewChecked}
          setChecked={setPreviewChecked}
        />
      </ModalContent>
    </>
  );
};

const CustomFieldCheckboxPreview = ({
  checked,
  setChecked,
}: {
  checked: boolean;
  setChecked: (checked: boolean) => void;
}) => {
  const { watch } = useFormContext<CheckboxCustomFieldInputData>();

  const fieldName = watch('fieldName');

  let title = 'Wpisz nazwe pola';
  if (fieldName && fieldName.length > 0) {
    title = fieldName;
  }

  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      <div className="flex flex-row items-start justify-start gap-2">
        <PrimitiveCheckbox
          id={title}
          checked={checked}
          onClick={(e) => setChecked(e.currentTarget.checked)}
        />
        <InputLabel
          label={title}
          required={watch('isFieldMandatory')}
          htmlFor={title}
        />
      </div>
      <InputHint hint={watch('hint')} />
    </div>
  );
};

export default CheckboxCustomFieldForm;
